import { transformData } from './transformer';
import { getMegaMenuV2 } from 'shared/api/mega-menu-v2';

export const getMenuContent = async (): Promise<any> => {
  const data = await getMegaMenuV2();
  return transformData(data);
};
